import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import { FilterTableService } from 'src/app/services/offers/filter-table.service';

@Component({
  selector: 'app-offer-search',
  templateUrl: './offer-search.component.html',
  styleUrls: ['./offer-search.component.scss'],
})
export class OfferSearchComponent implements OnInit {
  @Input() hidden: boolean;
  @Output() close: EventEmitter<any>;

  @HostBinding('class.hidden') get hide() {
    return this.hidden;
  }

  constructor(public fts: FilterTableService) {
    this.close = new EventEmitter();
  }

  ngOnInit() { }

  closeMenu() {
    this.close.emit();
  }

  updateOffersOnClose() {
    this.close.emit();
    this.fts.updateOffers.emit();
  }
}
